/*
* Salla Modal Component: popup modal used in most parts of the theme
* You can use these classes to target the elements in the component.
*/

@media screen and (max-width: 470px) {
  .modal-is-open {
    position: fixed;
    width: 100%;
  }
}

.s-modal {
  &-container{

  }
  &-wrapper {

  }
  &-close {

  }
  &-header {

  }
  &-header-inner {

  }
  &-header-content {

  }
  &-header-img {

  }
  &-icon {

  }
  &-bg-normal {

  }
  &-bg-success {

  }
  &-bg-error {

  }
  &-bg-primary {

  }
  &-text-success {

  }
  &-text-error {

  }
  &-title {

  }
  &-sub-title {

  }
  &-title-below {

  }
  &-body-slot {

  }
  &-body {

  }
  &-padding {

  }
  &-spacer {

  }
  &-align-middle {

  }
  &-align-top {

  }
  &-align-bottom {

  }
  &-overlay {

  }
  &-overlay-leaving {

  }
  &-entering {

  }
  &-leaving {

  }
  &-is-center {

  }
  // modal sizes
  &-xs {

  }
  &-sm {

  }
  &-md {

  }
  &-lg {

  }
  &-xl {

  }
  &-full {

  }
}
